import { render, staticRenderFns } from "./RatingSection.vue?vue&type=template&id=9785f1f0&scoped=true"
import script from "./RatingSection.vue?vue&type=script&lang=js"
export * from "./RatingSection.vue?vue&type=script&lang=js"
import style0 from "./RatingSection.vue?vue&type=style&index=0&id=9785f1f0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9785f1f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9785f1f0')) {
      api.createRecord('9785f1f0', component.options)
    } else {
      api.reload('9785f1f0', component.options)
    }
    module.hot.accept("./RatingSection.vue?vue&type=template&id=9785f1f0&scoped=true", function () {
      api.rerender('9785f1f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/Sections/Plans/RatingSection.vue"
export default component.exports